import { createFileRoute, redirect } from '@tanstack/react-router'
import { ViolationDetail } from '@/features/hr-violations/violation-detail'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/hr/violations/$violationId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'violation.view')) throw redirect({ to: '/hr' })
  },
  component: RouteScreen,
})
function RouteScreen() {
  const { violationId } = Route.useParams()
  return <ViolationDetail violationId={violationId} />
}
